import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Package } from 'lucide-react';
import { Client } from '@/types/client';
import ProductsTab from '@/components/business-rules/ProductsTab';

interface ProductsModalProps {
  client: Client | null;
  isOpen: boolean;
  onClose: () => void;
}

const ProductsModal: React.FC<ProductsModalProps> = ({ client, isOpen, onClose }) => {
  if (!client) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl max-h-[90vh] flex flex-col bg-white shadow-xl border border-gray-200 overflow-hidden">
        <DialogHeader className="border-b border-gray-100 pb-4 bg-white flex-shrink-0">
          <DialogTitle className="flex items-center gap-2 text-xl font-montserrat font-semibold text-gray-900">
            <Package className="w-5 h-5 text-primary-600" />
            Produtos e observações - {client.legal_name}
          </DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto pt-4">
          <ProductsTab client={client} />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ProductsModal;
